export default {
    image: null,
};
